import { useTranslation } from 'react-i18next'
import { StyledSearchContainer, StyledRoutingContainer } from './styled'
import IconAcross from '~/assets/images/protocol-logo-across.svg'

const CrossLoading: React.FC = () => {
  const { t } = useTranslation()

  return (
    <StyledSearchContainer>
      <StyledRoutingContainer>
        <img
          src={IconAcross}
          style={{
            width: '18px',
            height: '18px',
            position: 'absolute',
            bottom: 0,
          }}
        />
      </StyledRoutingContainer>
      <span>{t('price_lookup')}</span>
    </StyledSearchContainer>
  )
}

export default CrossLoading
